import { render, staticRenderFns } from "./pcOrderDetail.vue?vue&type=template&id=324720f0&scoped=true"
import script from "./pcOrderDetail.vue?vue&type=script&lang=js"
export * from "./pcOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./pcOrderDetail.vue?vue&type=style&index=0&id=324720f0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324720f0",
  null
  
)

export default component.exports